import { createFileRoute } from '@tanstack/react-router';

import { TendersPage } from '@/features/subcontracts/tenders-page';

export const Route = createFileRoute('/_app/org/$orgId/tenders/')({
  component: PageRoute,
});

function PageRoute() {
  const { orgId } = Route.useParams();
  return <TendersPage orgId={orgId} />;
}
